import App from './App';
import { connect } from 'react-redux'
import { push } from '../../actions/nav-actions'

const mapStateToProps = s => ({});

const mapDispatchToProps = d => ({
    push(routeName, state) {
        d(push(routeName, state));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/routers/App/index.js